import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  FormControl,
  FormLabel,
  Input,
  Select,
  Checkbox,
  Button,
  useToast,
  useColorModeValue,
  Flex,
  VStack,
} from "@chakra-ui/react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Course,Batch,Tutor } from "../Common/types";
import BatchStudentMapping from "../Components/BatchStudentMapping";
import BatchTermClasses from "../Components/BatchTermClasses";
import { toUtcISOString, parseUtc, fmtLocal, utcTimeToInput,inputTimeToUtc } from "../../utils/dates";


interface TokenPayload {
    sub: string;
    role_id: number;
    tenant_id: number;
    exp?: number;
  }

const ReviewBatch = () => {

    const buttonBg = useColorModeValue(
        'linear-gradient(to right, blue.50, blue.100)',
        'linear-gradient(to right, blue.600, blue.700)'
      );
      const buttonHoverBg = useColorModeValue(
        'blue.200',
        'blue.500'
      );
    

  const { batch_id } = useParams<{ batch_id: string }>();

  const [courseId, setCourseId] = useState<number | null>(null);

  const [tutorId, setTutorId] = useState<number | null>(null);

  const [tenantTutors, setTenantTutors] = useState<Tutor[]>([]);

  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);

    // Function to get tenant_id from the token
    const getTenantIdFromToken = (token: string): number | null => {
        try {
          const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
          return decoded.tenant_id || null;
        } catch (error) {
          console.error("Error decoding token:", error);
          return null;
        }
      };

const [courses, setCourses] = useState<Course[]>([]);

  // Assuming the `Batch` type is already imported
const [batchDetails, setBatchDetails] = useState<Batch>({
    id: 0, // Assuming an initial value of 0 for the batch ID
    tenant_id: 0, // Assuming an initial value of 0 for tenant_id, to be updated later
    course_id: 0, // Default value for course_id
    course_title: "", // Default course title
    title: "",
    frequency: "",
    start_time: "",
    end_time: "",
    location: "",
    start_date: "", // Initialize with today's date (ISO format)
    end_date: "", // Initialize with today's date (ISO format)
    meeting_link:"",
    is_active: true,
    created_at: new Date(), // Current timestamp for creation
    updated_at: new Date(), // Current timestamp for update
  });

  const toast = useToast();

  // Fetch students in batch
  const fetchTenantTutors = async () => {
    try {
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
        const response = await axios.get(
            `${apiurl}/tenants/${selectedTenant}/tutors`, 
            {
              params: { batch_id }, // Add batch_id as a query parameter
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          setTenantTutors(response.data);
    } catch (error) {
      console.error("Failed to load tutors", error);
      toast({
        title: "Error fetching tutors",
        description: "Failed to load tutors data.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Fetch courses for dropdown
  const fetchCourses = async () => {
    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || "https://default-url.com";
      const response = await axios.get(`${tenantsapiurl}/${selectedTenant}/courses`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setCourses(response.data);
      
    } catch (error) {
      console.error("Failed to load courses", error);
      toast({ title: "Error loading courses", status: "error" });
    }
  };

  const fetchBatch = async () => {
    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
       
      const response = await axios.get(`${apiurl}/batch-details/${batch_id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setBatchDetails(response.data);
      console.log("Batch Data",response.data);
    } catch (error) {
      console.error("Failed to load enrolled students", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token) ?? 0; // Use 0 if tenantId is null
      console.log("Tenant ID:", tenantId);
  
      setBatchDetails((prevDetails) => ({
        ...prevDetails, // Preserve other fields
        tenant_id: tenantId, // Update tenant_id
      }));
  
      setSelectedTenant(tenantId);

      if (Number(batch_id) > 0)
      {
        console.log("Batch Id:",batch_id);
        fetchBatch();
      }

    }
  }, [batch_id]);
  
  
  // Fetch courses only when `selectedTenant` is set
  useEffect(() => {
    if (selectedTenant) {
      fetchCourses();
      fetchTenantTutors();
    }
  }, [selectedTenant]); 


  const handleInputChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
) => {
  const { name, value } = e.target;

  // Convert empty string to null for tutor_id specifically
  const parsedValue = name === "tutor_id" && value === "" ? null : value;

  setBatchDetails((prev) => ({
    ...prev,
    [name]: parsedValue,
  }));
};

/*   const handleTimeChange = (time: string, name: string): void => {
    setBatchDetails((prev) => ({ ...prev, [name]: `${time}:00` }));
  }; */
 /* -------------------- TIME HANDLER -------------------- */
const handleTimeChange = (localHHmm: string, name: "start_time" | "end_time") => {
  const utc = inputTimeToUtc(localHHmm);

  console.log(`[${name}] onChange → local ${localHHmm} ⇒ UTC ${utc}`);
  setBatchDetails(prev => ({ ...prev, [name]: utc }));
};
   const handleDateChange = (date: string, name: string): void => {
     setBatchDetails((prev) => ({ ...prev, [name]: date }));
   };
  

   const handleSaveBatch = async () => {
    if (Number(batch_id) > 0)
        { 
            handleUpdateBatch();
        }
        else
        {
            handleCreateBatch();
        }


   }

  const handleCreateBatch = async () => {
    console.log("Batch Details sent to backend for processing",batchDetails);
    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
        const response = await axios.post(`${apiurl}/create-batch/`, batchDetails, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        //setCourses(response.data);
        toast({ title: "Batch Successfully created" });
      } catch (error) {
        
        toast({ title: "Error creating batch", status: "error" });
      }
  };

  const handleUpdateBatch = async () => {
    console.log("Batch Details sent to backend for processing",batchDetails);

    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';

        const response = await axios.put(`${apiurl}/update-batch/${batch_id}`, batchDetails, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        //setCourses(response.data);
        toast({ title: "Batch Successfully updated" });
      } catch (error) {
        
        toast({ title: "Error updating batch", status: "error" });
      }
  };

  return (
    <Box as="main" mx="auto" p={10} >
      <Accordion allowToggle defaultIndex={Number(batch_id) === 0 ? [0] : [0, 1, 2]} fontSize={"sm"} p={0}>
        {/* Panel 1: Batch Creation/Editing */}
        <AccordionItem isDisabled={Number(batch_id) === 0 && true} fontSize={"sm"}>
          <AccordionButton
          height="50px"
          backgroundImage={buttonBg} // Use backgroundImage for gradients
          _hover={{ bg: buttonHoverBg }}
          borderRadius="sm"
          mt={2}
          >
            <Box flex="1" textAlign="left" fontSize={"lg"} fontWeight={"bold"}>
              Batch Creation/Editing
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel p={0}>
   
            <Box fontSize="sm" maxWidth="800px" margin="auto" mt={2}>

                <VStack spacing={4} align="stretch">

                    {/* Course */}
                    <FormControl id="course_id" isRequired isDisabled={Number(batch_id) !== 0}>
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Course</FormLabel>
                        <Select
                        placeholder="Select Course"
                        name="course_id"
                        size="sm"
                        value={batchDetails.course_id}
                        onChange={handleInputChange}
                        >
                        {courses.map((course) => (
                            <option key={course.id} value={course.id}>
                            {course.title}
                            </option>
                        ))}
                        </Select>
                    </Flex>
                    </FormControl>

                  {/* Tutor */}
                  <FormControl id="tutor_id" >
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Tutor</FormLabel>
                        <Select
                        placeholder="Select Tutor"
                        name="tutor_id"
                        size="sm"
                        value={batchDetails.tutor_id}
                        onChange={handleInputChange}
                        >
                        {tenantTutors.map((tenantTutor) => (
                            <option key={tenantTutor.tutor_id} value={tenantTutor.tutor_id}>
                            {tenantTutor.given_name}
                            </option>
                        ))}
                        </Select>
                    </Flex>
                    </FormControl>

                    {/* Batch Title */}
                    <FormControl id="title" isRequired>
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Batch Title</FormLabel>
                        <Input
                        name="title"
                        size="sm"
                        value={batchDetails.title}
                        onChange={handleInputChange}
                        />
                    </Flex>
                    </FormControl>

                    {/* Frequency */}
                    <FormControl id="frequency" isRequired>
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Frequency</FormLabel>
                        <Select
                        placeholder="Select Frequency"
                        name="frequency"
                        size="sm"
                        value={batchDetails.frequency}
                        onChange={handleInputChange}
                        >
                        <option value="Daily">Daily</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Bi-weekly">Bi-weekly</option>
                        <option value="Once in two weeks">Once in two weeks</option>
                        </Select>
                    </Flex>
                    </FormControl>

                    {/* Start Time */}
{/*                     <FormControl id="start_time" isRequired>
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Start Time</FormLabel>
                        <Input
                        type="time"
                        size="sm"
                        onChange={(e) => handleTimeChange(e.target.value, "start_time")}
                        value={batchDetails.start_time.replace(":00", "")}
                        />
                    </Flex>
                    </FormControl> */}

                    {/* End Time */}
{/*                     <FormControl id="end_time" isRequired>
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>End Time</FormLabel>
                        <Input
                        type="time"
                        size="sm"
                        onChange={(e) => handleTimeChange(e.target.value, "end_time")}
                        value={batchDetails.end_time.replace(":00", "")}
                        />
                    </Flex>
                    </FormControl> */}

                    <FormControl id="start_time" isRequired>
                      <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize="sm">
                          Start Time
                        </FormLabel>
                        <Input
                          type="time"
                          size="sm"
                          value={utcTimeToInput(batchDetails.start_time)}
                          onChange={e => handleTimeChange(e.target.value, "start_time")}
                        />
                      </Flex>
                    </FormControl>


                    <FormControl id="end_time" isRequired>
                      <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize="sm">
                          End Time
                        </FormLabel>
                        <Input
                          type="time"
                          size="sm"
                          value={utcTimeToInput(batchDetails.end_time)}
                          onChange={e => handleTimeChange(e.target.value, "end_time")}
                        />
                      </Flex>
                    </FormControl>

                    {/* Location */}
                    <FormControl id="location">
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Location</FormLabel>
                        <Input
                        name="location"
                        size="sm"
                        value={batchDetails.location}
                        onChange={handleInputChange}
                        />
                    </Flex>
                    </FormControl>

                    {/* Meeting Link */}
                    <FormControl id="meeting_link">
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Meeting Link</FormLabel>
                        <Input
                        name="meeting_link"
                        size="sm"
                        value={batchDetails.meeting_link}
                        onChange={handleInputChange}
                        />
                    </Flex>
                    </FormControl>

                    {/* Start Date */}
                    <FormControl id="start_date" isRequired>
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Start Date</FormLabel>
                        <Input
                        type="date"
                        size="sm"
                        onChange={(e) => handleDateChange(e.target.value, "start_date")}
                        value={batchDetails.start_date}
                        />
                    </Flex>
                    </FormControl>

                    {/* End Date */}
                    <FormControl id="end_date" isRequired>
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>End Date</FormLabel>
                        <Input
                        type="date"
                        size="sm"
                        onChange={(e) => handleDateChange(e.target.value, "end_date")}
                        value={batchDetails.end_date}
                        />
                    </Flex>
                    </FormControl>

               


                    {/* Status */}
                    <FormControl id="is_active">
                    <Flex align="center" gap={4}>
                        <FormLabel minWidth="150px" mb="0" fontSize={"sm"}>Status</FormLabel>
                        <Checkbox
                        name="is_active"
                        isChecked={batchDetails.is_active}
                        onChange={(e) =>
                            setBatchDetails((prev) => ({ ...prev, is_active: e.target.checked }))
                        }
                        >
                        Active
                        </Checkbox>
                    </Flex>
                    </FormControl>

                </VStack>

            </Box>
            {/* Save Button */}
            <Box textAlign="left" mt={2}>
                <Button mb={2} colorScheme="blue" size="sm" borderRadius={"sm"} onClick={handleSaveBatch}>
                Save Batch
                </Button>
            </Box>

          </AccordionPanel>
        </AccordionItem>


            {/* Panel 2: Map Students to Batch */}
        <AccordionItem isDisabled={!selectedTenant || Number(batch_id) === 0} p={0}>
        <AccordionButton
        height="50px"
        backgroundImage={buttonBg} // Use backgroundImage for gradients
        _hover={{ bg: buttonHoverBg }}
        borderRadius="sm"
        mt={2}
        >
        <Box flex="1" textAlign="left" fontSize={"lg"} fontWeight={"bold"}>
              Map Students to the Batch
            </Box>
            <AccordionIcon />
        </AccordionButton>
        <AccordionPanel p={0}>
            {/* Logic for mapping students goes here */}
    
            {selectedTenant && Number(batch_id) !== 0 && (
                <BatchStudentMapping tenant_id={selectedTenant} batch_id={Number(batch_id)} />
            )}
          
        </AccordionPanel>
        </AccordionItem>


        {/* Panel 3: Generate Actual Classes */}
        <AccordionItem isDisabled={Number(batch_id) === 0}>
          <AccordionButton
          height="50px"
          backgroundImage={buttonBg} // Use backgroundImage for gradients
          _hover={{ bg: buttonHoverBg }}
          borderRadius="sm"
          mt={2}
          >
            <Box flex="1" textAlign="left"fontSize={"lg"} fontWeight={"bold"}>
              Generate Actual Classes
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel p={0}>
            {/* Logic for generating classes goes here */}
            <Box flex="1" textAlign="left">
            {Number(batch_id) !== 0 && (
                <BatchTermClasses course_id={batchDetails.course_id} batch_id={Number(batch_id)} />
            )}
            </Box>
          </AccordionPanel>
        </AccordionItem>

       
      </Accordion>
    </Box>
  );
};

export default ReviewBatch;
